// QuoteModal — wraps the shared <QuoteFlow /> inside the project's Modal.
//
// Used from BookingLeftPanel's "Get Quote" Quick Action. No footer — the
// action buttons live inside QuoteFlow itself (Send / New Quote / submit).
// The modal auto-closes when a quote is successfully sent.

import { Modal } from '../Modal/Modal';
import { QuoteFlow } from '../../../pages/quote/QuoteFlow';

export interface QuoteModalProps {
  open: boolean;
  onClose: () => void;
}

export function QuoteModal({ open, onClose }: QuoteModalProps): JSX.Element {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Scrap Quote"
      size="lg"
      ariaLabel="Scrap Quote Generator"
    >
      <QuoteFlow onSent={onClose} />
    </Modal>
  );
}
